import { Injectable } from '@angular/core';
import { IonicSafeString, ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    private currentMessage: string | IonicSafeString = '';

    constructor(public toaster: ToastController) { }

    showToaster(message: string | IonicSafeString, type: string = 'normal', infinite: boolean = false) {
        // Check if the message is the same as the currently shown message
        if (this.currentMessage === message) {
            // Don't trigger the toaster again if the message is the same
            return;
        }

        const toastOptions: ToastOptions = {
            message,
            icon: '/assets/icon/tick-circle-toaster.svg',
            cssClass: type === 'normal' ? 'bh-toaster' : type === 'error' ? 'bh-toaster add-error-clr' : 'bh-toaster success',
            duration: 5000,
            buttons: [
                {
                    icon: 'close',
                    htmlAttributes: {
                        'aria-label': 'close',
                    },
                    role: 'cancel',
                    handler: () => { },
                },
            ],
        };

        // Store the current message to avoid showing the same one again
        this.currentMessage = message;

        if (message) {
            this.toaster.create(toastOptions).then((toastData) => {
                const footer = document.querySelector('footer');
                if (footer !== null) {
                    footer.classList.add('footer-negative');
                }
                toastData.present();

                // Reset the current message after the toast is dismissed
                toastData.onDidDismiss().then(() => {
                    this.currentMessage = '';
                });
            });
        }
    }
}
